export enum RangeFilterType {
  AGE = 'AGE',
  SPENDING = 'SPENDING',
  INCOME = 'INCOME',
}
